/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Project team message
 */
import { ValidateUtils } from 'app/shared/utils';

export class ProjectTeamMessage { 
    /**
     * Subject
     */
    subject?: string;
    /**
     * Message
     */
    message?: string;

    constructor(item?: Partial<ProjectTeamMessage>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            subject: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.subject : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            message: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.message : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ProjectTeamMessage.isValid,
        };
    }

    static isValid(obj: ProjectTeamMessage): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ProjectTeamMessage.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.subject.isValid(item);
            result = result && validationObject.message.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

